const ufeApi = require('services/api/ufeApi');

// https://confluence.sephora.com/wiki/display/ILLUMINATE/Add+Payment+Credit+Card+API

function addPaymentCreditCard(creditCardInfo) {
    const url = '/api/payments/creditCard';
    return ufeApi.makeRequest(url, {
        method: 'POST',
        body: JSON.stringify(creditCardInfo)
    }).then(data => data.errorCode ? Promise.reject(data) : data);
}

module.exports = addPaymentCreditCard;
